import React from 'react';

export const AccessDenied: React.FC = () => <>Доступ запрещён</>;
